import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6"; // TikTok is in fa6
import "../App.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-links">
          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/regulations">Regulations</Link></li>
              <li><Link to ="/agents">Clearing Agents</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Support</h4>
            <ul>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/contact">FAQ</Link></li>
              <li><Link to="/news">News</Link></li>
              <li><Link to="/news">Latest Update</Link></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a href="https://www.facebook.com/ciappvtltd" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
              <a href="https://www.instagram.com/ciappvtltd/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.linkedin.com/company/ciap-pvt-ltd/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
              <a href="https://www.tiktok.com/@ciap.pvt.ltd" target="_blank" rel="noopener noreferrer"><FaTiktok /></a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Imports.lk. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;